<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon src="assets/fa-light/times.svg" slot="start"></ion-icon> {{'sa_close' | translate}}
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{'sa_variants_header' | translate}}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <app-product-item (click)="close()" [product]="p" *ngFor="let p of results"></app-product-item>
</ion-content>